module.exports = __webpack_public_path__ + "de77a722/img/boston-lights.a623432f.png";